import React from 'react';

export default function Pagination({
  currentPage,
  totalItems,
  itemsPerPage,
  onPageChange
}) {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  const handlePrevious = () => {
    if (currentPage > 1) onPageChange(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) onPageChange(currentPage + 1);
  };

  const pages = [];
  for (let i = 1; i <= totalPages; i++) {
    pages.push(i);
  }

  return (
    <div className="admin-pagination">
      <span>Showing {startItem}—{endItem} of {totalItems}</span>
      <div className="admin-pagination__pages">
        <span
          className="page-btn"
          onClick={handlePrevious}
          style={{ cursor: currentPage > 1 ? 'pointer' : 'default', opacity: currentPage > 1 ? 1 : 0.5 }}
        >
          ‹
        </span>
        {pages.map(page => (
          <span
            key={page}
            className={`page-btn ${currentPage === page ? 'is-active' : ''}`}
            onClick={() => onPageChange(page)}
            style={{ cursor: 'pointer' }}
          >
            {page}
          </span>
        ))}
        <span
          className="page-btn"
          onClick={handleNext}
          style={{ cursor: currentPage < totalPages ? 'pointer' : 'default', opacity: currentPage < totalPages ? 1 : 0.5 }}
        >
          ›
        </span>
      </div>
      <span>Per page · {itemsPerPage}</span>
    </div>
  );
}
